import * as React from "react";

import { css } from "glamor";

import { Colors, HTMLTable } from "@blueprintjs/core";

import {
	// Participant,
	Participant,
	Participants,
	Stage,
	Teams,
} from "../Interfaces";

const styles = {
	activeStage: (bool: boolean) =>
		css({
			backgroundColor: bool ? Colors.GRAY2 : "",
		}),
	stagenumber: css({
		verticalAlign: "middle !important",
		width: "50px !important",
	}),
	teamname: css({
		fontSize: "12px",
		fontStyle: "italic",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	}),
	table: css({
		width: "100%",
		paddingRight: "20px",
		tableLayout: "fixed",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	}),
	participantname: css({ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }),
};

interface Props {
	teams: Teams;
	participants: Participants;
	stages: Stage[];
	currentstage: number;
}

export default class FightOverview extends React.Component<Props, {}> {
	private makeCell = (participant: Participant) => (
		<td>
			<div {...styles.teamname}>{this.props.teams[participant.team_id].name}</div>
			<div {...styles.participantname}>{participant.firstname + " " + participant.lastname}</div>
		</td>
	);
	public render() {
		return (
			<div>
				<HTMLTable striped={true} condensed={true} {...styles.table}>
					<thead>
						<tr>
							<th {...styles.stagenumber}>Stage</th>
							<th>Reporter</th>
							<th>Opponent</th>
							<th>Reviewer</th>
						</tr>
					</thead>
					<tbody>
						{([] as Stage[])
							.concat(this.props.stages)
							.sort((a, b) => a.stagenumber - b.stagenumber)
							.map((stage) => {
								const allParticipants = Object.keys(this.props.participants).map(
									(key) => this.props.participants[key]
								);
								const reporter = allParticipants.find(
									(participant) => participant.id === stage.reporter_id
								)!;
								const opponent = allParticipants.find(
									(participant) => participant.id === stage.opponent_id
								)!;
								const reviewer = allParticipants.find(
									(participant) => participant.id === stage.reviewer_id
								)!;
								return (
									<tr
										key={stage.id}
										{...styles.activeStage(stage.stagenumber === this.props.currentstage)}
									>
										<td {...styles.stagenumber}>{stage.stagenumber}</td>
										{this.makeCell(reporter)}
										{this.makeCell(opponent)}
										{this.makeCell(reviewer)}
									</tr>
								);
							})}
					</tbody>
				</HTMLTable>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/FightOverview.tsx